import React from 'react';
import { badgesFor, primaryBadge } from '../../data/badges';
interface MemberBadgesProps {
  name: string;
  /** Own profile gets the earned note; other people's stay to the criteria. */
  own?: boolean;
}

/** The full set, as rows, on a profile. */
export function MemberBadges({
  name,
  own = false
}: MemberBadgesProps) {
  const badges = badgesFor(name);
  if (!badges.length) return null;
  return <ul className="grid gap-3 sm:grid-cols-2" data-id="element-343" data-mp="2uvouu6aopw6d">
      {badges.map(badge => <li key={badge.key} className="flex flex-col items-center gap-3 rounded-field border border-primary-tint bg-primary-soft px-4 py-5 text-center" data-id="element-344" data-mp="2q5044t6tx38a">
          <span className="flex h-14 w-14 items-center justify-center rounded-pill bg-primary" data-id="element-345" data-mp="2l3aof08nw1dv">
            <badge.icon aria-hidden="true" className="h-6 w-6 text-on-primary" data-id="element-346" data-mp="2g4pq56cyzrs2" />
          </span>
          <span className="flex flex-col gap-1" data-id="element-347" data-mp="2b9aeml2fq7yt">
            <span className="text-heading font-semibold text-primary-text" data-id="element-348" data-mp="276xa1zzfcg3m">{badge.label}</span>
            <span className="text-small text-on-primary-soft" data-id="element-349" data-mp="25almvj1ikysq">
              {own ? badge.earnedNote : badge.criteria}
            </span>
          </span>
        </li>)}
    </ul>;
}
interface BadgeMarkProps {
  name: string;
  className?: string;
}

/** A single quiet icon beside a name in a list. Labelled, never colour-only. */
export function BadgeMark({
  name,
  className = ''
}: BadgeMarkProps) {
  const badge = primaryBadge(name);
  if (!badge) return null;
  return <span title={`${badge.label}: ${badge.criteria}`} className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-pill bg-primary-soft ${className}`} data-id="element-350" data-mp="2t1r1xvzmrn1z">
      <span className="sr-only" data-id="element-351" data-mp="2j31gxucftmhi">{badge.label}</span>
      <badge.icon aria-hidden="true" className="h-3 w-3 text-primary-text" data-id="element-352" data-mp="2j1gn66xy67kp" />
    </span>;
}